import { MyPhotos } from '@/components/composed';

/**
 * PhotosPage - Displays user's photos
 *
 * Routes:
 * - /photos (authenticated user's photos)
 * - /u/:username/photos (specific user's photos)
 * - /:username/photos (old pattern - backward compatibility)
 *
 * TODO: Extract username param and fetch photos for specific user when implemented
 */
export function PhotosPage() {
  return <MyPhotos />;
}
